/* istanbul ignore file */

// Queries
import contactMessagesCount from './ContactMessagesCountQuery.gql';
import usersCount from './UsersCountQuery.gql';
import bookingRequestsCount from './BookingRequestsCountQuery.gql';

// eslint-disable-next-line import/prefer-default-export
export const Query = {
  contactMessagesCount,
  usersCount,
  bookingRequestsCount,
};
